import axiosTouri from "../../axiosTuri";

// Get All Items
export const getAllItems = async () => {
  const res = await axiosTouri.get(`destinations`);
  if (res.data.success === true) {
    return res.data;
  }
};
